export const STRATEGY_ACTION_TYPE = {
  getStrategiesRequest: "GET_STRATEGIES_REQUEST",
  getStrategiesSuccess: "GET_STRATEGIES_SUCCESS",
  getStrategiesError: "GET_STRATEGIES_ERROR",

  // Form-specific strategies
  getStrategiesByFormIdRequest: "GET_STRATEGIES_BY_FORM_ID_REQUEST",
  getStrategiesByFormIdSuccess: "GET_STRATEGIES_BY_FORM_ID_SUCCESS",
  getStrategiesByFormIdError: "GET_STRATEGIES_BY_FORM_ID_ERROR",

  deleteStrategyRequest: "DELETE_STRATEGY_REQUEST",
  deleteStrategySuccess: "DELETE_STRATEGY_SUCCESS",
  deleteStrategyError: "DELETE_STRATEGY_ERROR",
};
